import { StraightenOutlined } from '@mui/icons-material'

export default StraightenOutlined
